

 <div class="main_form">

    <mat-accordion>

        <mat-expansion-panel  hideToggle #example2 [(expanded)]="isExpanded" class="mat-elevation-z10" >
        <mat-expansion-panel-header class="mat-expan">
        <mat-panel-title >
        <h3 class="header"> Basic Information</h3>
        </mat-panel-title>
        <em class="ti-arrow-circle-down" style="font-size: 2.5rem;" *ngIf="!example2.expanded"></em>
        <em class="ti-arrow-circle-right" style="font-size: 2.5rem;" *ngIf="example2.expanded"></em>


        </mat-expansion-panel-header>

        <form [formGroup]="incidentForm">

      <div class="incidence_forms">
        <h3 class="form_sec-title">Primary Info of Incident</h3>
        <div class="primary_incident-info">
          <div class="the_input">
            <div class="alter">
              <label for="">Incident no<span style="color:red">*</span></label>
              <div class="radios">
                <input type="radio" name="incidentNo" checked [disabled]="selectedIncidentId" (change)="onChangeNotificationNoGenerator($event.target.value)" value="Manual" />
                <label for="">Manual</label>
                <input type="radio" name="incidentNo" [disabled]="selectedIncidentId" (change)="onChangeNotificationNoGenerator($event.target.value)" value="Automatic" />
                <label for="">Auto</label>
              </div>
            </div>
            <input type="text" formControlName="IncidentNotificationId" class="default_input" />
          </div>

          <div class="the_input">
            <label for="">Incident Name<span style="color:red">*</span></label>
            <input type="text" formControlName="IncidentName" class="default_input" />
          </div>

          <div class="the_input">
            <label for="">Incident Category<span style="color:red">*</span></label>
            <select class="default_input"  formControlName="IncidentCategoryId" (change)="onFilterIncidentSubCategory($event.target.value)">
              <option value="">Select Item</option>
              <option *ngFor="let incidentcat of incidentcategorys" [value]="incidentcat.id">{{ incidentcat.IncidentCategoryName }}</option>
            </select>
          </div>

          <div class="the_input">
            <label for="">Incident Sub Category</label>
            <select class="default_input" formControlName="IncidentSubCategoryId">
              <option value="">Select Item</option>
              <option *ngFor="let incidentsubcat of filterIncidentSubCategory" [value]="incidentsubcat.id">{{incidentsubcat.IncidentSubCategoryName}}</option>
            </select>
          </div>

          <div class="the_input">
            <label for="">Incident Date<span style="color:red">*</span></label>
            <input type="date" formControlName="IncidentDate" class="default_input" />
          </div>

          <div class="the_input">
            <label for="">Reported Date</label>
            <input type="date" formControlName="ReportedDate" class="default_input" />
          </div>

          <div class="the_input">
            <label for="">JIV Date</label>
            <input type="date" class="default_input" formControlName="JIVDate" />
          </div>

          <div class="the_input">
            <label for="">JIV Survey Date</label>
            <input type="date" class="default_input" formControlName="JIVSurveyDate" />
          </div>

          <div class="the_input">
            <label for="">Location of Incident</label>
            <input type="text" formControlName="LocationOfIncident" class="default_input" />
          </div>

          <div class="the_input">
            <label for="">Cause of Incident<span style="color:red">*</span></label>
            <textarea cols="30" rows="4" class="default_input" formControlName="CauseOfIncident"></textarea>
          </div>

          <div class="the_input">
            <label for="">Nature of Pollution<span style="color:red">*</span></label>
            <textarea cols="30" rows="4" class="default_input" formControlName="NatureOfPolution"></textarea>
          </div>
        </div>
        <!-- <h3 class="form_sec-title">JIV Data</h3>
        <div class="jiv_data"></div> -->
        <ng-container *ngIf="incidentType !== 'NonOilSpill'">



        <h3 class="form_sec-title">Spillage Info.</h3>

        <div class="spillage_info">
          <div class="measurement_info" style="display: flex; flex-direction: column; padding-bottom: 2rem;">
            <div class="the_input">
              <label for="">Qty Spilled</label>
              <input type="number" formControlName="QtySpilled" class="default_input" />
            </div>

            <div class="the_input">
              <label for="">Select Unit of Measure</label>
              <select class="default_input" formControlName="QtyUOM">
                <option value="">select option</option>
                <option *ngFor="let unitofmeasure of uoms" [value]="unitofmeasure.id">{{unitofmeasure.UomName}}</option>
             </select>
            </div>

          </div>
          <div class="measurement_info" style="display: flex; flex-direction: column; padding-bottom: 2rem;">
            <div class="the_input">
              <label for="">Qty/Vol.Recovered</label>
              <input type="number" formControlName="QtyVolRecovered" class="default_input" />
            </div>
            <div class="the_input">
              <label for="">Select Unit of Measure</label>
              <select class="default_input" formControlName="QtyRecoveredUOM">
                <option value="">select option</option>
                <option *ngFor="let unitofmeasure of uoms" [value]="unitofmeasure.id">{{unitofmeasure.UomName}}</option>
             </select>
            </div>
          </div>
          <div class="measurement_info" style="display: flex; flex-direction: column;">
            <div class="the_input">
              <label for="">Total Area Of Impact</label>
              <input type="number" formControlName="TotalAreaOfImpact" class="default_input" />
            </div>
            <div class="the_input" style="margin-bottom: 2rem">
              <label for="">Select Unit of Measure</label>
              <select class="default_input" formControlName="UomId">
                <option value="">select option</option>
                <option *ngFor="let unitofmeasure of uoms" [value]="unitofmeasure.id">{{unitofmeasure.UomName}}</option>
             </select>
            </div>
          </div>
          <div class="measurement_info" style="display: flex; flex-direction: column; padding-bottom: 2rem; height: 166.667px;">
            <div class="the_input">
              <label for="">Quantum of Impact</label>
              <select class="default_input" formControlName="IncidentQuantumId">
                <option value="">select option</option>
                <option *ngFor="let quant of quantums" [value]="quant.id">{{quant.IncidentQuantumName}} </option>
              </select>
            </div>
          </div>
        </div>
      </ng-container>

        <h3 class="form_sec-title">Geo-spatial Info.</h3>
        <div class="geospatial_info">
          <div class="measurement_info">
            <div class="the_input">
              <label for="">Easting</label>
              <input type="number" formControlName="Easting" class="default_input" />
            </div>
            <div class="the_input">
              <label for="">Northing</label>
              <input type="number" formControlName="Northing" class="default_input" />
            </div>
          </div>

          <div class="the_input">
            <label for="">Select
              <ng-container *ngIf="incidentType !== 'NonOilSpill'; else nonOilSpill">
                Clean Up Status
              </ng-container>
              <ng-template #nonOilSpill>
                Incident Status
              </ng-template>
              <span style="color:red">*</span></label>
            <select class="default_input" formControlName="CleanUpStatusId">
              <option value="">select option</option>
              <option *ngFor="let cleanupstat of cleanupstatuss" [value]="cleanupstat.id">{{cleanupstat.CleanUpStatusName}}</option>

            </select>
          </div>

          <div class="the_input">
            <label for="">Remark</label>
            <input type="text" formControlName="Remarks" class="default_input" />
          </div>
        </div>
      </div>

      <div class="down" style="text-align: center; padding:2rem 0; width:100%;">
        <button  class="default_primary-button" (click)="onSubmit(incidentForm.getRawValue())">Save</button>
      </div>



</form>
</mat-expansion-panel>

</mat-accordion>
  </div>






 <div class="other_contents" >
  <mat-tab-group class="ta" color="accent" [disableRipple]=true [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="tabChanged($event)" #tabGroup  style="margin-bottom: 5rem;" *ngIf="showTab">
    <mat-tab class="tab">

      <ng-template mat-tab-label  style="background-color:#000 !important; color:#fff">
        <mat-icon class="example-tab-icon">info</mat-icon>
         Impacted Asset
      </ng-template>

     <cradua-impactedasset
        [landTitles] = "landTitles"
        [impactedassets] = "impactedassets"
        [states]="states"
        [lgas]="lgas"
        [communitys]="communities"
        [selectedIncidentId]="selectedIncidentId"
        (emitSave)="onEmitAssetSubmit($event)"
        (deleteEvent)="onEmitAssetDelete($event)"
        *ngIf="selectedIncidentId"
     >

     </cradua-impactedasset>
      </mat-tab>

      <mat-tab class="tabs">
        <ng-template mat-tab-label class="tab">
          <mat-icon class="example-waves-icon">waves</mat-icon>
          Impacted Community
        </ng-template>
        <cradua-impactedcommunity
        [states] = "states"
        [lgas] ="lgas"
        [communities] = "communities"
        [selectedIncidentId]="selectedIncidentId"
        [impactedcommunitys]="impactedcommunitys"
        (emitimpactedcommunity)="onSubmitImpactedCommunity($event)"
        >

        </cradua-impactedcommunity>
        </mat-tab>

        <mat-tab class="tabs">
            <ng-template mat-tab-label class="tab">
              <mat-icon class="example-tab-icon">contacts</mat-icon>
              Address Book
            </ng-template>
            <cradua-address-book

       [states]="states"
       [lgas]="lgas"
       [communities]="communities"
       [banks]="banks"
       [titles]="titles"
       [addressBooks]="addressBooks"
       [isLoadingAddressBook]="isLoadingAddressBook"
       (emitAddressBook)="onSearchAddressBook($event)"
       (emitSaveAddressBook)="onSaveAddressBook($event)"
       (emitClearAddressBook)="onEmitClearAddressBook($event)"

       >
       </cradua-address-book>

            </mat-tab>

            <mat-tab class="tabs">
                <ng-template mat-tab-label class="tab">
                  <mat-icon class="example-stars-icon">stars</mat-icon>
                 Payment
                </ng-template>
             <cradua-payment-container
             [PaymentType]="PaymentType"
             [ownershiptypes] = "ownershiptypes"
              [uoms]="uoms"
              [addressbooks]="addressBooks"
              [quantums]="quantums"
              [terrains]="terrains"
              [LandTitleSerialNo]="selectedIncidentId.id"
             ></cradua-payment-container>

      </mat-tab>


      <mat-tab class="tabs">
          <ng-template mat-tab-label class="tab">
            <mat-icon class="example-explore-icon">explore</mat-icon>
            Area of Impact Details
          </ng-template>
          <cradua-areaofimpact
      [uoms] = "uoms"
      [partys]="partys"
      [terrains]="terrains"
      [selectedIncidentId]="selectedIncidentId"
      [areaofimpacts]="areaofimpacts"
      (emitareaofimpact)="onSubmitAreaOfImpact($event)"
      ></cradua-areaofimpact>

  </mat-tab>

      <mat-tab class="tabs">
          <ng-template mat-tab-label class="tab">
            <mat-icon class="example-explore-icon">explore</mat-icon>
            Area Map of Spill
          </ng-template>
          <cradua-area-map-of-spill
            [selectedIncidentId]="selectedIncidentId"
            [appConfig]="appConfig"
            (emitAreaOfSpill)="onSubmitAreaOfSpill($event)"
      ></cradua-area-map-of-spill>

      </mat-tab>

      <mat-tab class="tabs">
          <ng-template mat-tab-label class="tab">
            <mat-icon class="example-explore-icon">explore</mat-icon>
            View Area Map of Spill
          </ng-template>
          <cradua-view-area-map-of-spill
            [selectedIncidentId]="selectedIncidentId"
></cradua-view-area-map-of-spill>

  </mat-tab>

  <mat-tab class="tab">
    <ng-template mat-tab-label class="tab">
      <mat-icon class="example-tab-icon">folder_shared</mat-icon>
     Document
    </ng-template>

    <cradua-incident-document
    [BulkIds]="BulkIds"
    [type]="'tenement'"
    [selectedLandTitle]="selectedIncidentId"
    [documentTypeCodes]="documentTypeCodes"
    [documentTypes]="documentTypes"
    [securityClassifications]="securityClassifications"
    [fileLocations]="fileLocations"
    [fetchDocuments]="fetchDocuments"
    [isLoadingDocument]="isLoadingDocument"
    [progress]="progress"
    [completed]="completed"
    [error]="error"
    [isInProgress]="isInProgress"
    [isReady]="isReady"
    [hasFailed]="hasFailed"
    (emitUpload)="onUploadFile($event)"
    (emitSaveManyDoc)="onSaveManyDoc($event)"
    (emitCancel)="onCancelUpload($event)"
    (emitReset)="onResetUpload($event)"
    ></cradua-incident-document>

    </mat-tab>


      </mat-tab-group>

    </div>






